import { gql } from "@apollo/client/core";

export default gql`
    mutation DeletePrevention($id: ID!) {
        deletePrevention(input: { id: $id }) {
            errors
            status
            statusCode
        }
    }
`
